// extracted by mini-css-extract-plugin
export default {"chartContainerBackground":"ProfileAttributesMetrics_chartContainerBackground__iSCwd","loadingContainer":"ProfileAttributesMetrics_loadingContainer__pd7FX"};